import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "home",
  class: "h100 d-flex align-items-center bg-gradient2 section-padding"
}
const _hoisted_2 = {
  id: "container",
  class: "container"
}
const _hoisted_3 = { class: "row justify-content-center text-center" }
const _hoisted_4 = {
  key: 0,
  style: {"text-align":"center"},
  class: "my-5"
}
const _hoisted_5 = {
  key: 1,
  class: "col-sm-6 col-lg-10"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "¡Felicidades!", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle text-white max700 mb-5" }, " Revisamos tus datos, y cumples con los requisitos para solicitar cualquiera de estas opciones: ", -1)
const _hoisted_8 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_spinner = _resolveComponent("spinner")!
  const _component_cards = _resolveComponent("cards")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_spinner, {
                  text: "Estamos obteniendo las mejores opciones para ti.",
                  color: "#ffffff",
                  "text-color": "#ffffff"
                })
              ]))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (c) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-sm-12 col-md-12 col-lg-4 cards-results",
                      key: c.id
                    }, [
                      _createVNode(_component_cards, {
                        name: c.name,
                        src: c.b64Picture,
                        aside: c.aside,
                        content: c.content,
                        id: c.id,
                        urls: c.urls,
                        handleOnClick: _ctx.handleOnClick
                      }, null, 8, ["name", "src", "aside", "content", "id", "urls", "handleOnClick"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}